import { toast } from "react-toastify";
import {
  getResolvedZebraErrorMessage,
  printZebraZpl,
} from "./zebraBrowserPrint";

const printBarcode = async (content: any) => {
  try {
    await printZebraZpl(`${content}`);
  } catch (error) {
    toast.error(getResolvedZebraErrorMessage(error));
  }
};

export default printBarcode;
